import { useIntl } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export function StepSubmitted() {
	const intl = useIntl();

	const { portal, language } = useParams();
	const { search } = useLocation();
	const navigate = useNavigate();

	const query = new URLSearchParams(search);
	const refNumber = query.get("refNumber");

	return (
		<div className="text-center py-4">
			<div className="mb-3">
				<i className="bi bi-check-circle-fill" style={{ color: "green", fontSize: 64 }}></i>
			</div>
			<h4 className="mb-2">{intl.formatMessage({ id: "success_page_title" })}</h4>

			<p className="text-muted">{intl.formatMessage({ id: "success_page_message" })}</p>
			<div className="mb-2 d-flex flex-column align-items-center gap-2">
				<div>
					<span className="fw-bold">{intl.formatMessage({ id: "success_page_reference_number" })}</span>
					<span className="ms-2 text-primary fs-5">{refNumber}</span>
				</div>
				<a
					href="#"
					className="btn btn-link p-0"
					style={{ color: "#bc231e", fontWeight: 600, textDecoration: "underline" }}
					onClick={() => navigate(`/${portal}/${language}`, { replace: true })}
				>
					{intl.formatMessage({ id: "success_page_button" })}
				</a>
			</div>
		</div>
	);
}
